module.exports = __webpack_public_path__ + "a0a12987c38ededdab0d8b419e662a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background/track-foreground.png
// module id = 631
// module chunks = 0